import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (v: number): string => {
    if (v >= 10000) return (v / 10000).toFixed(1) + '万';
    return v.toString();
  };

  return (
    <Link
      to={'/article/' + comic.slug}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={comic.title + ' - 韩漫免费在线阅读'}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-2">
            <span className="px-2 py-0.5 text-xs bg-primary-500 text-white rounded-full whitespace-nowrap">
              {comic.status}
            </span>
            <span className="px-2 py-0.5 text-xs bg-accent-500 text-white rounded-full whitespace-nowrap">
              {comic.category}
            </span>
          </div>
        </div>
        {comic.isHot && (
          <div className="absolute top-2 left-2">
            <span className="px-2 py-0.5 text-xs bg-primary-500 text-white rounded-full whitespace-nowrap">
              热门
            </span>
          </div>
        )}
        {comic.isNew && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs bg-accent-500 text-white rounded-full whitespace-nowrap">
              新作
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
          </div>
          <div className="flex items-center gap-1 text-foreground-500">
            <i className="ri-eye-line text-xs"></i>
            <span className="text-xs">{formatViews(comic.views)}</span>
          </div>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {comic.tags.slice(0, 2).map(tag => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-[10px] bg-secondary-100 text-secondary-700 rounded whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}